/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
/**
 * author: tman
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import ItemTitle from '../ItemTitle';

export default class InputText extends React.Component {

  constructor(props) {
    super(props);
    this.setupData(props)
  }

  valueDidChange = (event) => {
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
    event.preventDefault();

    const { type, handleTextChange, content, maxLength } = this.props;
    const val = !!maxLength ? event.target.value.substr(0, maxLength) : event.target.value;
    if (type === 'tel' && /[^\d]/.test(val)) {
      return false;
    }
    handleTextChange && handleTextChange(content.questionRel, val, event);

    return false;
  };

  blurAction = (event)=> {
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
    event.preventDefault();

    const val = event.target.value;
    const { handleBlurAction, content } = this.props;
    handleBlurAction && handleBlurAction(content.questionRel, val, event);

    return false;
  };

  focusAction = (event) => {
    // event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
    event.preventDefault();

    const { handleFocusAction } = this.props;
    handleFocusAction && handleFocusAction();

    return false;
  };

  setupData(props) {
    const {
      content,
      isNeedLabel,
      id,
    } = props;
    this.isRequired = content.questionRel && !!content.questionRel.condition ? !!JSON.parse(content.questionRel.condition).mandatory : false;
    this.controlId = isNeedLabel ?
      ((content.questionRel && content.questionRel.questionId && content.questionRel.questionId) || content.dataKey) :
      !!id ? id : '';
    this.titleObj = {
      questionMark: content.questionMark,
      question: content.subtitle,
      questionTip: content.questionTip,
      controlFor: this.controlId
    };
    this.inputTitle = (content.subtitle && content.subtitle.title) || (content.subtitle && content.subtitle.text) || '';
  }

  componentWillReceiveProps(nextProps) {
    this.setupData(nextProps)
  }

  render() {
    const {
      content,
      handleTextDel,
      hasDelBtn,
      type,
      maxLength,
      overlapLabel,
      parentIndex,
      dataIndex,
      removeText,
      className,
      FormGroupClassName,
      isNeedLabel,
      ariaLabel,
      ariaDescribedby
    } = this.props;

    const maxLengthFin = maxLength===0 ? undefined : maxLength;
    const ariaDescribedbyId = ariaDescribedby || this.controlId+'-err';
    return (
      <div className="input-text-box clearfix">
        <ItemTitle content={ this.titleObj } isNeedLabel={ isNeedLabel } />
        <FormGroup
          validationState={ content.isError ? 'error' : null }
          className={ FormGroupClassName }
          controlId={ this.controlId }
        >
          { overlapLabel && !!overlapLabel.labelContent &&
          <span className={`label-mark float-${overlapLabel.float}`}>
                        { overlapLabel.labelContent }
                    </span>
          }
          <FormControl
            type={ type }
            value={ content.textValue || "" }
            placeholder={ content.placeholder }
            disabled={ content.isDisabled }
            name={ content.inputName }
            onChange={ this.valueDidChange }
            maxLength={ maxLengthFin }
            data-parentindex={ parentIndex }
            data-index={ dataIndex }
            data-key={ content.dataKey }
            className={ className }
            onBlur={ this.blurAction }
            onFocus = { this.focusAction }
            autoComplete="off"
            //WAI-ARIA Web Accessibility Specification:
            aria-required={ this.isRequired }//Is the element value required true=required
            aria-disabled={ content.isDisabled }//Disabled state true=Inactivation state
            //Whether the value is wrong true=Validation does not pass,
            aria-invalid={ content.isError }
            aria-label={ ariaLabel } //A string value marks the current element.
            aria-describedby={ariaDescribedbyId}
          />
          <HelpBlock id={ariaDescribedbyId}>{ content.errorMessage }</HelpBlock>
          { hasDelBtn &&
          <a data-index={dataIndex} href={' '} aria-label={removeText} onClick={handleTextDel} className="delete-btn" data-key={`${content.questionRel.questionIndicator}-removeText`}>
            { removeText }
          </a>
          }
        </FormGroup>
      </div>
    )
  }
};

InputText.propTypes = {
  content: PropTypes.object.isRequired,
  handleTextDel: PropTypes.func,
  index: PropTypes.number,
  type: PropTypes.string,
  dataIndex: PropTypes.number,
  parentIndex: PropTypes.number,
  overlapLabel:PropTypes.object,
  maxLength: PropTypes.number,
  hasDelBtn: PropTypes.bool,
  removeText: PropTypes.string,
  className: PropTypes.string,
  FormGroupClassName: PropTypes.string,
  handleTextChange: PropTypes.func,
  handleBlurAction: PropTypes.func,
  handleFocusAction: PropTypes.func,
  isNeedLabel: PropTypes.bool,
  inputTitle: PropTypes.string,
  ariaLabel: PropTypes.string,
  id: PropTypes.string,
};


InputText.defaultProps = {
  content: {},
  hasDelBtn: false,
  type: 'text',
  removeText: 'Remove',
  isNeedLabel: true,
  inputTitle:''
};






// WEBPACK FOOTER //
// ./src/shared/AOForm/components/InputText/InputText.js